// eslint-disable-next-line
import {injectable} from "inversify";
import {TYPE, rootContainer} from '../container/root';
import {IHttpService} from "../http-service";

export interface ISendEmailArg {
    message: string;
    contactEmail: string;
}

@injectable()
class EmailService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    async sendEmail(input: ISendEmailArg): Promise<any> {
        return await this.httpService.post(`/rms-api/send-sales-email`, input);
    }
}

export default EmailService;
